import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import PageHeaderErrors from '~/glm/components/shared/layout/page-header-errors';
import GdsEventModel from '~/glm/models/gds/gds-event-model';
import styles from './page-header.scss';

class PageHeader extends Component {
  render() {
    const { heading, subHeading, children, event, showZeroState } = this.props;
    return (
      <Fragment>
        <div className={styles.contentHeader}>
          <div className={styles.pageHeader}>
            <div>
              {heading}
              {subHeading}
            </div>
            {children}
          </div>
        </div>
        {event && !showZeroState & <PageHeaderErrors event={event} />}
      </Fragment>
    );
  }
}

PageHeader.propTypes = {
  heading: PropTypes.node,
  subHeading: PropTypes.node,
  children: PropTypes.node,
  event: PropTypes.instanceOf(GdsEventModel),
  showZeroState: PropTypes.bool,
};

PageHeader.defaultProps = {
  heading: null,
  subHeading: null,
  children: null,
  event: null,
  showZeroState: false,
};

export default PageHeader;
